import './PaymentInfoForm.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const PaymentInfoForm = () => {
    return ( 
        <div className="paymentinfoform">
            <h3>Payment Information</h3>
            <form action="" className="container-fluid">
                <div className="row ">
                    
                    <div className="d-flex flex-column col-lg-3 col-md-6 col-sm-12">
                        <label htmlFor="card">CARD NUMBER</label>
                        <input type="number" name="" id="" placeholder="0000" />
                    </div>
                    <div className="d-flex flex-column col-lg-3 col-md-6 col-sm-12">
                        <label htmlFor="">&nbsp;</label>
                        <input type="number" name="" id="" placeholder="0000" />
                    </div>
                    <div className="d-flex flex-column col-lg-3 col-md-6 col-sm-12">
                        <label htmlFor="">&nbsp;</label>
                        <input type="number" name="" id="" placeholder="0000" />
                    </div>
                    <div className="d-flex flex-column col-lg-3 col-md-6 col-sm-12">
                        <label htmlFor="">&nbsp;</label>
                        <input type="number" name="" id="" placeholder="0000" />
                    </div>
                </div>

                <div className="row">
                    <div className="d-flex flex-column col-lg-8 col-md-6 col-sm-12">
                        <label htmlFor="">EXPIRY DATE</label>
                        <input type="number" name="" id="" placeholder="Expiry date"/>
                    </div>
                    <div className="d-flex flex-column col-lg-4 col-md-6 col-sm-12">
                        <label htmlFor="">CVV</label>
                        <input type="number" name="" id="" placeholder="CVV"/>
                    </div>
                </div>
            </form>
        </div>
     );
}
 
export default PaymentInfoForm;